import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { X, Camera } from "@phosphor-icons/react";

// Camera-based QR scanner that returns the scanned text via onScan.
export default function QRScanner({ onScan, onClose }) {
  const [error, setError] = useState("");
  const scannerRef = useRef(null);
  const startedRef = useRef(false);

  useEffect(() => {
    let cancelled = false;
    const start = async () => {
      try {
        const el = "qr-reader-region";
        scannerRef.current = new Html5Qrcode(el);
        const cams = await Html5Qrcode.getCameras();
        if (!cams || cams.length === 0) {
          setError("No camera detected");
          return;
        }
        // prefer rear camera
        const rear = cams.find((c) => /back|rear|environment/i.test(c.label)) || cams[cams.length - 1];
        if (cancelled) return;
        await scannerRef.current.start(
          rear.id,
          { fps: 10, qrbox: { width: 240, height: 240 } },
          (decoded) => {
            onScan?.(decoded);
          },
          () => {}
        );
        startedRef.current = true;
      } catch (e) {
        setError(e?.message || "Failed to start camera");
      }
    };
    start();
    return () => {
      cancelled = true;
      if (scannerRef.current && startedRef.current) {
        scannerRef.current.stop().catch(() => {}).finally(() => {
          try { scannerRef.current.clear(); } catch {}
        });
      }
    };
  }, [onScan]);

  return (
    <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-md flex items-center justify-center p-4" onClick={onClose}>
      <div className="brutal-card p-6 w-full max-w-md" onClick={(e) => e.stopPropagation()} data-testid="qr-scanner-modal">
        <div className="flex justify-between items-center mb-4">
          <div>
            <div className="font-mono text-xs text-[#FF4F00] tracking-widest">// SCAN QR CODE</div>
            <h2 className="font-display font-black text-2xl flex items-center gap-2">
              <Camera size={22} weight="bold" /> Point at Tool
            </h2>
          </div>
          <button onClick={onClose} data-testid="qr-scanner-close" className="text-[#A1A1AA] hover:text-white">
            <X size={20} />
          </button>
        </div>
        {error ? (
          <div className="border-l-4 border-[#D32F2F] bg-[#D32F2F]/10 px-4 py-3 text-sm">{error}</div>
        ) : (
          <div id="qr-reader-region" className="border border-[#27272A] overflow-hidden" style={{ minHeight: 260 }} />
        )}
        <div className="mt-3 font-mono text-[10px] text-[#52525B] uppercase tracking-widest">
          // grant camera permission to scan //
        </div>
      </div>
    </div>
  );
}
